export default "__VITE_PUBLIC_ASSET__bf13da2b__"